<template>
  <v-container fluid>
    <v-radio-group
      v-model="internalElaboracionPropia"
      hide-details
      class="mt-0"
      :disabled="disabled"
    >
      <v-radio
        label="Elaboración propia"
        :value="true"
        color="primary"
      ></v-radio>
      <v-radio
        label="Comprado a proveedor"
        :value="false"
        color="primary"
      ></v-radio>
    </v-radio-group>
  </v-container>
</template>

<script>
export default {
  name: "FormProductoEsElaboracionPropia",
  props: {
    producto: {
      type: Object,
      required: true,
    },
    // Mantener 'disabled' para controlar la interactividad del grupo de radios
    disabled: {
      type: Boolean,
      default: false,
    },


  },
  data() {
    return {
      // Usamos una data interna para v-model y luego emitimos el cambio al prop.
      // Esto es una buena práctica para evitar mutar props directamente.
      internalElaboracionPropia: this.producto.es_elaboracion_propia,
    };
  },
  watch: {
    // Escucha cambios en la prop 'producto.es_elaboracion_propia' desde el padre
    "producto.es_elaboracion_propia": function (newVal) {
      this.internalElaboracionPropia = newVal;
    },
    // Escucha cambios en la data interna y emite el evento al padre
    internalElaboracionPropia: function (newVal) {
      this.$emit("set-elab-prop", newVal);
      // Opcional: si la prop producto está directamente vinculada al v-model
      // y necesitas mutarla directamente (menos recomendado, pero a veces necesario
      // en componentes complejos o si producto no es reactivo en el padre de forma directa)
      // this.producto.es_elaboracion_propia = newVal;
    },
  },
};
</script>

<style  scoped>
</style>